import styled, { DefaultTheme, CSSObject } from 'styled-components';

export interface BtnStyleConfig {
    colorNormal: (theme: DefaultTheme) => string,
    borderColorNormal: (theme: DefaultTheme) => string,
    backgroundColorNormal: (theme: DefaultTheme) => string,

    colorHover: (theme: DefaultTheme) => string,
    borderColorHover: (theme: DefaultTheme) => string,
    backgroundColorHover: (theme: DefaultTheme) => string,

    colorActive: (theme: DefaultTheme) => string,
    borderColorActive: (theme: DefaultTheme) => string,
    backgroundColorActive: (theme: DefaultTheme) => string,

    colorDisabled: (theme: DefaultTheme) => string,
    borderColorDisabled: (theme: DefaultTheme) => string,
    backgroundColorDisabled: (theme: DefaultTheme) => string,

    outlineColorFocus: (theme: DefaultTheme) => string,

    font: (theme: DefaultTheme) => string,
}

export type BtnStyleConfigP = {
    cfg: BtnStyleConfig,
    theme: DefaultTheme,
}


export const G = {
    getColorNormal: ({ cfg, theme }: BtnStyleConfigP) => cfg.colorNormal(theme),
    getBackgroundColorNormal: ({ cfg, theme }: BtnStyleConfigP) => cfg.backgroundColorNormal(theme),
    getBorderColorNormal: ({ cfg, theme }: BtnStyleConfigP) => cfg.borderColorNormal(theme),

    getColorHover: ({ cfg, theme }: BtnStyleConfigP) => cfg.colorHover(theme),
    getBorderColorHover: ({ cfg, theme }: BtnStyleConfigP) => cfg.borderColorHover(theme),
    getBackgroundColorHover: ({ cfg, theme }: BtnStyleConfigP) => cfg.backgroundColorHover(theme),

    getColorActive: ({ cfg, theme }: BtnStyleConfigP) => cfg.colorActive(theme),
    getBorderColorActive: ({ cfg, theme }: BtnStyleConfigP) => cfg.borderColorActive(theme),
    getBackgroundColorActive: ({ cfg, theme }: BtnStyleConfigP) => cfg.backgroundColorActive(theme),

    getColorDisabled: ({ cfg, theme }: BtnStyleConfigP) => cfg.colorDisabled(theme),
    getBorderColorDisabled: ({ cfg, theme }: BtnStyleConfigP) => cfg.borderColorDisabled(theme),
    getBackgroundColorDisabled: ({ cfg, theme }: BtnStyleConfigP) => cfg.backgroundColorDisabled(theme),

    getOutlineColorFocus: ({ cfg, theme }: BtnStyleConfigP) => cfg.outlineColorFocus(theme),

    getFont: ({ cfg, theme }: BtnStyleConfigP) => cfg.font(theme),
}


export interface ButtonProps {
    fluid?: boolean
}

const fluided = ({ fluid }: ButtonProps): CSSObject => ({
    width: fluid ? '100%' : undefined,
});



const Base = styled.button<ButtonProps & BtnStyleConfigP>`
    border: 1px solid;
    border-radius: 4px;
    letter-spacing: .02em;
    padding: 1.072em 1.7em;
    line-height: 0;
    transition: all .33s ease-in-out;
    cursor: pointer;
    ${fluided};
    outline: none;
    user-select: none;
    font-family: ${G.getFont};


    &:active {
        transition: none;
    }

    &:disabled {
        cursor: inherit;
        background-color: transparent;
    }
`;

export const Btn = styled(Base)<ButtonProps & BtnStyleConfigP>`
    background-color: ${G.getBackgroundColorNormal};
    border-color: ${G.getBorderColorNormal};
    color: ${G.getColorNormal};

    &:hover {
        background-color: ${G.getBackgroundColorHover};
        border-color: ${G.getBorderColorHover};
        color: ${G.getColorHover};
    }

    &:active {
        background-color: ${G.getBackgroundColorActive};
        border-color: ${G.getBorderColorActive};
        color: ${G.getColorActive};
    }

    &:disabled {
        background-color: ${G.getBackgroundColorDisabled};
        border-color: ${G.getBorderColorDisabled};
        color: ${G.getColorDisabled};
    }
`;
